export const nano_pullover = {
  msrp: 49.99,
  variants: [
    ['SHORT SLEEVE', 'LONG SLEEVE'],
    ['HOODIE', 'QUARTER ZIP'],
    ["MEN'S CUT", "WOMEN'S CUT"],
  ],
  infoLink: 'https://www.teamtriton.com/nano-pullover.html',
  items: [
    {
      number: 'ST099',
      hasModel: false,
    },
    {
      number: 'ST100',
      hasModel: false,
    },
    {
      number: 'ST101',
      hasModel: false,
    },
    {
      number: 'ST102',
      hasModel: false,
    },
    {
      number: 'ST103',
      hasModel: false,
    },
    {
      number: 'ST104',
      hasModel: false,
    },
    {
      number: 'ST105',
      hasModel: false,
    },
    {
      number: 'ST106',
      hasModel: false,
    },
    {
      number: 'ST107',
      hasModel: false,
    },
    {
      number: 'ST108',
      hasModel: false,
    },
    {
      number: 'ST109',
      hasModel: false,
    },
    {
      number: 'ST110',
      hasModel: false,
    },
    {
      number: 'ST111',
      hasModel: false,
    },
  ],
};
